import { useQueries } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const BASE_URL = process.env.REACT_APP_ENDPOINT;

const QUERY_CONFIGS = [
  {
    queryKey: "wq-data-summary",
    url: `${BASE_URL}/api/wq-data-summary`,
  },
  {
    queryKey: "wq-data-list-parameters",
    url: `${BASE_URL}/api/wq-data-list-parameters`,
  },
  {
    queryKey: "wq-data-stats-by-parameter",
    url: `${BASE_URL}/api/wq-data-stats-by-parameter`,
  },
  {
    queryKey: "wq-data-processed",
    url: `${BASE_URL}/api/wq-data-processed`,
  },
];

export function useWqData() {
  const { getAccessTokenSilently } = useAuth0();

  const results = useQueries(
    QUERY_CONFIGS.map((config) => ({
      queryKey: config.queryKey,
      queryFn: async () => {
        const token = await getAccessTokenSilently();
        const headers = { Authorization: `Bearer ${token}` };
        const { data } = await axios.get(config.url, { headers });
        return data;
      },
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
    }))
  );

  const [
    { data: summary = [], isLoading: summaryLoading },
    { data: parameters = [], isLoading: paramsLoading },
    { data: stats = [], isLoading: statsLoading },
    { data: processed = [], isLoading: processedLoading },
  ] = results;

  return {
    summary,
    parameters,
    stats,
    processed,
    isLoading:
      summaryLoading || paramsLoading || statsLoading || processedLoading,
    hasError: results.some((r) => r.error),
  };
}
